/**
 * @class
 * @classdesc Класс элемента в библиотеке {@link module:media.AssetsLibrary AssetsLibrary}
 * @memberof module:media
 */
class Asset {

    /**
     * @constructor
     * @param {String} name Уникальное название, по которому можно будет обращаться к элементу в библиотеке
     * @param {String} src URL изображения
     * @param {Number} w ширина одного кадра в спрайте в масштабе 1х
     * @param {Number} h высота одного кадра спрайта в масштабе 1х
     * @param {Number} f количество кадров в спрайте (расположены вертикально)
     * @param {Number} l количество слоёв в спрайте (расположены горизонтально)
     */
    constructor(name, src, w = undefined, h = undefined, f = 1, l = 1) {

        /**
         * @member {String} module:media.Asset#name Название, по которому потом можно обращаться к элементу в библиотеке
         */
        this.name = name + '';

        /**
         * @member {String} module:media.Asset#src URL изображения
         */
        this.src = src + '';

        /**
         * @member {Number} module:media.Asset#width ширина одного кадра в спрайте в масштабе 1х
         */
        this.width = w;

        /**
         * @member {Number} module:media.Asset#height высота одного кадра спрайта в масштабе 1х
         */
        this.height = h;

        /**
         * @member {Number} module:media.Asset#frames количество кадров в спрайте (расположены вертикально)
         */
        this.frames = f;

        /**
         * @member {Number} module:media.Asset#layers количество слоёв в спрайте (расположены горизонтально)
         */
        this.layers = l;

        /**
         * @member {Image} module:media.Asset#bitmap Изображение после загрузки
         */
        this._bitmap = null;

        this.texture = null;

        /**
         * @member {Boolean} module:media.Asset#ready Флаг выставляется в TRUE после того, как изображение загружено и готово к использованию.
         * @ignore
         */
        this.ready = !!(this.width && this.height);

        /**
         * @member {Function} module:media.Asset#spriteClass Конструктор спрайта (по умолчанию {@link module:display.Sprite Sprite})
         */
        this.spriteClass = null;

        this._scale = 1;
    }

    get bitmap() {
        return this._bitmap;
    }

    set bitmap(val) {
        this._bitmap = val;
        this.texture = PIXI.Texture.from(PIXI.BaseTexture.from(val));
        this.texture.baseTexture.resolution = this._scale;
        this.texture.update();
        if (!PIXI.utils.TextureCache[val.src]) {
            PIXI.Texture.addToCache(this.texture, val.src);
        }
        this.scale = this._scale; // update values
    }

    get scale() {
        return this._scale;
    }

    set scale(scale) {
        if (!scale || isNaN(scale)) scale = this._scale;
        this._scale = scale;
        if (this.ready) return;
        if (!this._detectSize()) return;
        this.frames = Math.max(1, ~~this.frames);
        this.layers = Math.max(1, ~~this.layers);
        this.width = Math.ceil((this.width / this.layers) / this._scale);
        this.height = Math.ceil((this.height / this.frames) / this._scale);
        this.ready = true;
    }

    /**
     * Определяет размеры спрайта либо как указано, либо пытается автоматом
     * @ignore
     */
    _detectSize() {
        if (!this.bitmap) return false;
        try {
            this.width = ~~this.width
                || ~~this.bitmap.width
                || ~~this.bitmap.naturalWidth
                || 0;
            this.height = ~~this.height
                || ~~this.bitmap.height
                || ~~this.bitmap.naturalHeight
                || 0;
        }
        catch (e) { }

        return (!isNaN(this.width) && !isNaN(this.height));
    }

    /**
     * Преобразовывает размеры соответственно указанному масштабу и количеству кадров/слоёв. Если размер неизвестен - пытается определить его сам.
     * @ignore
     */
    applyScale(scale = this._scale) {
    }
}

export default Asset;
